import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { Membership } from 'src/features/userManagement/types';
import type { MutationConfig } from 'src/lib/react-query.ts';

const RESOURCE = '/parkings/:parkingId/memberships/:membershipId/';

interface DTO {
    parkingId: string;
    membershipId: string;
    status?: 'active' | 'inactive';
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<Membership> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMembership };
